import { useState } from 'react'
import { Button } from '@components/primitives/Button.js'
import { Modal } from '@components/primitives/Modal.js'
import { formatCurrency } from '@utils/format.js'
import type { OrcamentoMaterial } from '@services/db.js'

type Props = {
  open: boolean
  item: OrcamentoMaterial
  onConfirm: () => Promise<void>
  onClose: () => void
}

export function ConfirmPagarMaterialModal({ open, item, onConfirm, onClose }: Props) {
  const [busy, setBusy] = useState(false)

  async function handle() {
    setBusy(true)
    try {
      await onConfirm()
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal
      open={open}
      title='Registrar pagamento'
      size='sm'
      onClose={onClose}
      actions={
        <div className='cf3-modal-actions'>
          <Button variant='ghost' onClick={onClose} disabled={busy}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={() => void handle()} loading={busy}>
            Marcar como pago
          </Button>
        </div>
      }
    >
      <p className='cf3-confirm-msg'>
        Lançar <strong>{formatCurrency(item.valorTotal)}</strong> de {item.material} (
        {item.fornecedor}) em Financeiro › Materiais como pago?
      </p>
    </Modal>
  )
}
